import React from "react";
import { Link } from "react-router-dom";

const Sidebar = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const role = user?.role || "user";

  const handleMenuClick = () => {
    if (window.innerWidth < 768) {
      document.body.classList.remove("sidebar-open");
      document.body.classList.add("sidebar-closed", "sidebar-collapse");
    }
  };

  return (
    <aside className="main-sidebar sidebar-dark-primary elevation-4">
      <Link to="/dashboard" className="brand-link" onClick={handleMenuClick}>
        <span className="brand-text font-weight-light">HELIOS - IMS</span>
      </Link>

      <div className="sidebar">
        <nav className="mt-2">
          <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu">
            
            {/* Dashboard for all */}
            <li className="nav-item">
              <Link to="/dashboard" className="nav-link" onClick={handleMenuClick}>
                <i className="nav-icon fas fa-tachometer-alt"></i>
                <p>Dashboard</p>
              </Link>
            </li>

            {/* REQUISITION MODULE */}
            {(role === "user" || role === "superadmin") && (
              <>
                <li className="nav-item">
                  <Link to="/dashboard/requisition" className="nav-link" onClick={handleMenuClick}>
                    <i className="nav-icon fas fa-file-alt"></i>
                    <p>New Requisition</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/dashboard/requisition-list" className="nav-link" onClick={handleMenuClick}>
                    <i className="nav-icon fas fa-file-signature"></i>
                    <p>My Requisitions</p>
                  </Link>
                </li>
              </>
            )}

            {(role === "store_manager" || role === "superadmin") && (
              <li className="nav-item">
                <Link to="/dashboard/requisition-list" className="nav-link" onClick={handleMenuClick}>
                  <i className="nav-icon fas fa-list"></i>
                  <p>All Requisitions</p>
                </Link>
              </li>
            )}

            {(role === "Principal" || role === "Management") && (
              <li className="nav-item">
                <Link to="/dashboard/requisition-list" className="nav-link" onClick={handleMenuClick}>
                  <i className="nav-icon fas fa-eye"></i>
                  <p>View Requisitions</p>
                </Link>
              </li>
            )}

            {/* PURCHASE ORDER MODULE */}
            {(role === "store_manager" || role === "superadmin") && (
              <>
                <li className="nav-item">
                  <Link to="/dashboard/purchase-orders" className="nav-link" onClick={handleMenuClick}>
                    <i className="nav-icon fas fa-shopping-cart"></i>
                    <p>Purchase Orders</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/dashboard/create-purchase-order" className="nav-link" onClick={handleMenuClick}>
                    <i className="nav-icon fas fa-plus-circle"></i>
                    <p>Create Purchase Order</p>
                  </Link>
                </li>
              </>
            )}

            {(role === "Principal" || role === "Management") && (
              <li className="nav-item">
                <Link to="/dashboard/purchase-orders" className="nav-link" onClick={handleMenuClick}>
                  <i className="nav-icon fas fa-shopping-cart"></i>
                  <p>View PO</p>
                </Link>
              </li>
            )}

            {/* GRN */}
            {(role === "store_manager" || role === "superadmin") && (
              <li className="nav-item">
                <Link to="/dashboard/grns" className="nav-link" onClick={handleMenuClick}>
                  <i className="nav-icon fas fa-file-alt"></i>
                  <p>ALL GRN</p>
                </Link>
              </li>
            )}

            {/* WORK ORDERS */}
            {(role === "store_manager" || role === "superadmin") && (
              <>
                <li className="nav-item">
                  <Link to="/dashboard/work-orders" className="nav-link" onClick={handleMenuClick}>
                    <i className="nav-icon fas fa-hard-hat"></i>
                    <p>Work Orders</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/dashboard/create-work-order" className="nav-link" onClick={handleMenuClick}>
                    <i className="nav-icon fas fa-plus-circle"></i>
                    <p>Create Work Order</p>
                  </Link>
                </li>
              </>
            )}

            {(role === "Principal" || role === "Management") && (
              <li className="nav-item">
                <Link to="/dashboard/work-orders" className="nav-link" onClick={handleMenuClick}>
                  <i className="nav-icon fas fa-hard-hat"></i>
                  <p>View Work Orders</p>
                </Link>
              </li>
            )}

            {/* STOCK */}
            {(role !== "user") && (
              <li className="nav-item">
                <Link to="/dashboard/stock" className="nav-link" onClick={handleMenuClick}>
                  <i className="nav-icon fas fa-cubes"></i>
                  <p>Stock</p>
                </Link>
              </li>
            )}

            {/* ITEMS / VENDORS */}
            {(role === "store_manager" || role === "superadmin") && (
              <>
                <li className="nav-item">
                  <Link to="/dashboard/items" className="nav-link" onClick={handleMenuClick}>
                    <i className="nav-icon fas fa-box"></i>
                    <p>Items</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/dashboard/vendors" className="nav-link" onClick={handleMenuClick}>
                    <i className="nav-icon fas fa-truck"></i>
                    <p>Vendor Details</p>
                  </Link>
                </li>
              </>
            )}

            {/* USERS */}
            {role === "superadmin" && (
              <li className="nav-item">
                <Link to="/dashboard/users" className="nav-link" onClick={handleMenuClick}>
                  <i className="nav-icon fas fa-users"></i>
                  <p>Users</p>
                </Link>
              </li>
            )}

            {/* REPORTS */}
            {(role !== "user") && (
              <li className="nav-item">
                <Link to="/dashboard/reports" className="nav-link" onClick={handleMenuClick}>
                  <i className="nav-icon fas fa-chart-bar"></i>
                  <p>Reports</p>
                </Link>
              </li>
            )}
          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default Sidebar;
